/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Audience kind.
 */
export const PluginAudienceKind = {
  Everyone: "everyone",
  Role: "role",
  DirectoryGroup: "directory_group",
  DirectoryAttribute: "directory_attribute",
} as const;
/**
 * Audience kind.
 */
export type PluginAudienceKind = ClosedEnum<typeof PluginAudienceKind>;

export type PluginAudience = {
  /**
   * Display name for the audience.
   */
  displayName: string;
  /**
   * Audience kind.
   */
  kind: PluginAudienceKind;
  /**
   * Number of current members, when the audience has an enumerable membership.
   */
  memberCount?: number | undefined;
  /**
   * Principal URN used to assign the audience to a plugin.
   */
  principalUrn: string;
};

/** @internal */
export const PluginAudienceKind$inboundSchema: z.ZodMiniEnum<
  typeof PluginAudienceKind
> = z.enum(PluginAudienceKind);

/** @internal */
export const PluginAudience$inboundSchema: z.ZodMiniType<
  PluginAudience,
  unknown
> = z.pipe(
  z.object({
    display_name: z.string(),
    kind: PluginAudienceKind$inboundSchema,
    member_count: z.optional(z.int()),
    principal_urn: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "member_count": "memberCount",
      "principal_urn": "principalUrn",
    });
  }),
);

export function pluginAudienceFromJSON(
  jsonString: string,
): SafeParseResult<PluginAudience, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PluginAudience$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PluginAudience' from JSON`,
  );
}
